/*global window, setTimeout, document, module, matchMedia */
/**
 * @author Valeriy Siestov
 *
 * @description Main JS object of this site
 * @namespace
 * @property {object} browser - Contains data about browser and operation system
 */
var FRONDEVO = {
    controls: {
        desktop: matchMedia('(min-width: 1024px)')
    },
    browser: (function () {

        var os = '',
            version,
            ua = window.navigator.userAgent,
            platform = window.navigator.platform,
            result = {

                /**
                 * Contain operation system
                 *
                 * @member {Object}
                 */
                os: {
                    win: false,
                    mac: false,
                    linux: false,
                    android: false,
                    ios: false
                },

                /**
                 * Contain current browser
                 *
                 * @member {Object}
                 */
                browser: {
                    opera: false,
                    ie: false,
                    firefox: false,
                    chrome: false,
                    safari: false,
                    android: false
                },
                version: 0
            };

        if (/MSIE/.test(ua)) {
            version = /MSIE \d+[.]\d+/.exec(ua)[0].split(' ')[1];
            result.browser.ie = true;
            result.version = parseInt(version, 10);
        } else if (/Android/.test(ua)) {
            result.os.android = true;
            result.browser.android = true;

            if (/Chrome/.test(ua)) {
                version = /Chrome\/[\d\.]+/.exec(ua)[0].split('/')[1];
                result.version = parseInt(version, 10);
                result.browser.chrome = true;

                result.browser.android = false;
            }

            if (/Firefox/.test(ua)) {
                version = /Firefox\/[\.\d]+/.exec(ua)[0].split('/')[1];
                result.browser.firefox = true;
                result.version = parseInt(version, 10);

                result.browser.android = false;
            }

        } else if (/Chrome/.test(ua)) {
            version = /Chrome\/[\d\.]+/.exec(ua)[0].split('/')[1];
            result.browser.chrome = true;
            result.version = parseInt(version, 10);
        } else if (/Opera/.test(ua)) {
            result.browser.opera = true;
        } else if (/Firefox/.test(ua)) {
            version = /Firefox\/[\.\d]+/.exec(ua)[0].split('/')[1];
            result.browser.firefox = true;
            result.version = parseInt(version, 10);
        } else if (/Safari/.test(ua)) {

            if ((/iPhone/.test(ua)) || (/iPad/.test(ua)) || (/iPod/.test(ua))) {
                result.os.ios = true;
            }

            result.browser.safari = true;
        }

        if (!version) {

            version = /Version\/[\.\d]+/.exec(ua);

            if (version) {

                if (version) {
                    version = version[0].split('/')[1];
                } else {
                    version = /Opera\/[\.\d]+/.exec(ua)[0].split('/')[1];
                }

                result.version = parseInt(version, 10);
            } else {

                if (document.all.length) {
                    result.version = 11;
                    result.browser.ie = true;
                }

            }
        }

        if (platform === 'MacIntel' || platform === 'MacPPC') {
            result.os.mac = true;
        } else if (platform === 'Win32' || platform === 'Win64') {
            result.os.win = true;
        } else if (!os && /Linux/.test(platform)) {
            result.os.linux = true;
        } else if (!os && /Windows/.test(ua)) {
            result.os.win = true;
        } else if (!os && /android/.test(ua)) {
            result.os.android = true;
        }

        return result;

    }()),

    /**
     * Global functions
     *
     * @type {object}
     */
    global: {
        addEvents: function (list, event, handler) {
            var count = list.length,
                i;

            for (i = 0; i < count; i++) {
                list[i].addEventListener(event, handler, false);
            }
        },

        /**
         * Save touch state and position
         *
         * @method
         * @memberOf FRONDEVO
         * @param {Object} event - Touch event object
         */
        touchScrollStart: function (event) {
            "use strict";

            event.stopPropagation();
            this.allowUp = (this.scrollTop > 0);
            this.allowDown = (this.scrollTop < this.scrollHeight - this.clientHeight);
            this.lastY = event.touches[0].clientY;
        },

        /**
         * Check and process touch scrolling position
         *
         * @method
         * @memberOf FRONDEVO
         * @param {Object} event - Touch event object
         */
        touchScrollProcessing: function (event) {
            "use strict";

            if (FRONDEVO.controls.desktop.matches) {
                return;
            }

            var up = (event.touches[0].clientY > this.lastY),
                down = !up;

            this.lastY = event.touches[0].clientY;

            if ((up && this.allowUp) || (down && this.allowDown)) {
                event.stopPropagation();
            } else {
                if (this.scrollHeight !== this.clientHeight || this.scrollHeight + 1 !== this.clientHeight) {
                    event.preventDefault();
                }
            }
        },

        /**
         * Stretch object by rules of cover
         *
         * @memberOf FRONDEVO
         * @param {HTMLElement} object
         * @param {number} viewPortWidth
         * @param {number} viewPortHeight
         */
        cover: function (object, viewPortWidth, viewPortHeight) {
            "use strict";

            var viewPortRatio = viewPortWidth / viewPortHeight,
                imageRatio,
                resultWidth,
                resultHeight,
                hiddenTop = 0,
                hiddenLeft = 0;

            object.style.display = 'none'; // need for correct rendering in firefox (start)

            object.style.width = 'auto';
            object.style.height = 'auto';
            object.style.top = '';
            object.style.left = '';
            object.removeAttribute('width');
            object.removeAttribute('height');

            object.style.display = '';  // need for correct rendering in firefox (end)

            imageRatio = (object.width || object.videoWidth) / (object.height || object.videoHeight);

            if (imageRatio <= viewPortRatio) {
                resultWidth = viewPortWidth;
                resultHeight =  viewPortWidth / imageRatio;

                hiddenTop = (viewPortHeight - resultHeight) / 2;
            } else {
                resultWidth = viewPortHeight * imageRatio;
                resultHeight = viewPortHeight;

                hiddenLeft = (viewPortWidth - resultWidth) / 2;
            }

            object.style.display = 'none'; // need for correct rendering in firefox (start)

            object.width = resultWidth;
            object.height = resultHeight;
            object.style.width = resultWidth + 'px';
            object.style.height = resultHeight + 'px';
            object.style.top = hiddenTop + 'px';
            object.style.left = hiddenLeft + 'px';
            object.style.objectFit = 'unset';
            object.style.display = '';  // need for correct rendering in firefox (end)
        },

        /**
         * Stretch object by rules of contain
         *
         * @memberOf FRONDEVO
         * @param {HTMLElement} object
         * @param {number} viewPortWidth
         * @param {number} viewPortHeight
         */
        contain: function (object, viewPortWidth, viewPortHeight) {
            "use strict";

            var viewPortRatio = viewPortWidth / viewPortHeight,
                imageRatio = object.width / object.height,
                resultWidth,
                resultHeight,
                hiddenTop = 0,
                hiddenLeft = 0;

            if (imageRatio <= viewPortRatio) {
                resultWidth = viewPortHeight * imageRatio;
                resultHeight =  viewPortHeight;

                hiddenLeft = (viewPortWidth - resultWidth) / 2;
            } else {
                resultWidth = viewPortWidth;
                resultHeight = viewPortWidth / imageRatio;

                hiddenTop = (viewPortHeight - resultHeight) / 2;
            }

            object.width = resultWidth;
            object.height = resultHeight;
            object.style.width = resultWidth + 'px';
            object.style.height = resultHeight + 'px';
            object.style.top = hiddenTop + 'px';
            object.style.left = hiddenLeft + 'px';
        },

        fixFit: function (list) {
            var count = list.length,
                i,
                global = FRONDEVO.global,
                cover = global.cover,
                contain = global.contain,
                tempParent;

            if (window.CSS && CSS.supports('object-position', 'left top') && !FRONDEVO.browser.browser.firefox) {
                return;
            }

            for (i = 0; i < count; i++) {
                tempParent = list[i].parentNode;

                if (list[i].getAttribute('data-fit') === 'cover') {
                    cover(list[i], tempParent.clientWidth, tempParent.clientHeight);
                } else {
                    contain(list[i], tempParent.clientWidth, tempParent.clientHeight);
                }

            }

        },

        resizeForObjectFit: function (event) {
            var ctrl = FRONDEVO.controls,
                list = ctrl.objectFitList;

            clearTimeout(ctrl.resizeTimeout);
            ctrl.resizeTimeout = setTimeout(function () {
                FRONDEVO.global.fixFit(list);
            }, 500);
        },

        transitionEnd: function (event) {
            if ($(event.target).hasClass('tEndElement') || $(event.target).hasClass('tEndElement2')) {
                if ($(event.target).data('tcallback')) {
                    var callback = $(event.target).data('tcallback');
                    if (event.originalEvent.propertyName.indexOf(callback.prop) > -1) {
                        if (typeof callback.callback === 'function') {
                            callback.callback();
                        }
                    }

                }
            }

        },

        transitionEnd2: function (event) {
            if ($(event.target).hasClass('tEl')) {
                if ($(event.target).data('tcallback')) {
                    var callback = $(event.target).data('tcallback');

                    console.log('!!!');

                    if (event.originalEvent.propertyName.indexOf(callback.prop) > -1) {
                        if (typeof callback.callback === 'function') {
                            callback.callback();
                        }
                    }

                }
            }

        },

        formSubmit: function (event) {
            var form = event.target,
                formData;

            if (!module.validation.check(form)) {
                event.preventDefault();
                return;
            }

            if (!form.hasAttribute('data-ajax')) {
                return;
            }

            event.preventDefault();

            $(form).addClass('loading');
            formData = new FormData(form);

            fetch(form.getAttribute('action'), {
                method: form.getAttribute('method'),
                body: formData
            }).then(function (response) {
                module.listener.exec(form.getAttribute('id'), response);
                TweenMax.to(window, 0.3, {
                    scrollTo : { y: 0},
                    ease: Power1.easeOut
                });
            }).catch(function (error) {
                console.error('submit form error', error);
            });
        },

        formApplicationReceive: function (response) {
            var middle = document.querySelector('.middle-text'),
                answer = document.querySelector('.form-answer span');

            response.json().then(function (json) {
                answer.innerHTML = json.message;

                middle.classList.add('response');
            });
        }
    },

    /**
     * Get site controls
     *
     * @method
     * @memberOf FRONDEVO
     */
    getControls: function () {
        var ctrl = FRONDEVO.controls;

        ctrl.siteWrap = document.querySelector('.site-wrap');
    },

    /**
     * Set event listeners
     *
     * @method
     * @memberOf FRONDEVO
     */
    setEventList: function () {
        var ctrl = FRONDEVO.controls,
            global = FRONDEVO.global,
            siteWrap = ctrl.siteWrap;

        if (FRONDEVO.browser.os.ios) {
            global.addEvents([siteWrap], 'touchstart', global.touchScrollStart);
            global.addEvents([siteWrap], 'touchmove', global.touchScrollProcessing);
            window.addEventListener('resize', global.resizeForObjectFit, false);
        }

        $(document).on('transitionend', '.tEndElement', global.transitionEnd);
        $(document).on('transitionend', '.tEndElement2', global.transitionEnd2);
        window.addEventListener('submit', function (event) {
            // form validate apply
            $('[data-fld-attr-required]').each(function (key, value) {
                $.each( value.attributes, function( index, attr ) {
                    if (attr.name.search('data-fld-attr-') > -1) {
                        var realAttr = attr.name.match(/data-fld-attr-(.+)/)[1];
                        $(value).attr(realAttr, '');
                    }
                } );
            });

            global.formSubmit(event);
        }, false);

        if (window.module && module.listener) {
            module.listener.add({name: 'form-application', handler: global.formApplicationReceive});
        }

        // form start validate fix
        $('input').on('blur', function () {
            var el = this;
            $.each( el.attributes, function( index, attr ) {
                if (attr.name.search('data-fld-attr-') > -1) {
                    var realAttr = attr.name.match(/data-fld-attr-(.+)/)[1];
                    $(el).attr(realAttr, '');
                }
            } );
        });

        // scroll to by click on start screen's btn
        $('.full-height__layout .arrow').on('click', function () {
            TweenMax.to($(window), 1, {
                scrollTo: {y: $(window).height() * 0.4},
                ease:Power2.easeInOut
            });
        });

    },

    /**
     * Set startup configuration
     *
     * @method setConfig
     * @memberOf FRONDEVO
     */
    setConfig: function () {
        var ctrl = FRONDEVO.controls,
            global = FRONDEVO.global,
            list,
            count,
            i;

        ctrl.objectFitList = list = document.querySelectorAll('[data-fit]');
        count = list.length;

        for (i = 0; i < count; i++) {

            list[i].onload = function () {
                global.fixFit([this]);
            };

            if (list[i].complete) {
                global.fixFit([list[i]]);
            }
        }

        ctrl.isMobDevice = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|touch|opera mini/i
            .test(navigator.userAgent.toLowerCase()));

        ctrl.popup = new Popup();
        if (typeof FDWorks === 'function') {
            ctrl.works = new FDWorks();
        }

        if (window.MainLoader) {
            ctrl.mainLoader = new MainLoader();
        }

        if (window.viewportUnitsBuggyfill) {
            viewportUnitsBuggyfill.init();
        }

        // projects page modules
        if (window.ListScroll) {
            window.scrollDelta = {
                temp: 0,
                now: 1
            };
            ctrl.listScroll = new ListScroll();
        }
        if (window.ListScroll) {
            ctrl.projectsFilter = new ProjectsFilter();
        }

    },

    objectFitPolyfill: function () {
        if (!('object-fit' in document.body.style)) {
            $('[data-fd-object-fit]').each(function (key, value) {
                var src = $(this).attr('src');
                $(value).addClass('invisible');
                $(value).parent().css({'background': 'url(' + src + ')'});
            });
        }
    },

    /**
     * Init functionality of this site
     *
     * @constructs
     * @method init
     * @memberOf FRONDEVO
     */
    init: function () {
        window.addEventListener('DOMContentLoaded', function () {
            FRONDEVO.getControls();
            FRONDEVO.setEventList();
            FRONDEVO.setConfig();
            FRONDEVO.objectFitPolyfill();
        }, false);
    }
};

FRONDEVO.init();